export const environment = {
  production: true,
  api: 'https://qwikkitordering.azurewebsites.net/',
  apiQwikkitOrdering: 'https://qwikkitorderingapi.azurewebsites.net/',
  packagePlanningAPI: 'https://packageplanning.azurewebsites.net/api/PackagePlanning',
  apiMobile: 'https://qwikkitorderingapi-mobile-app-dev.azurewebsites.net/',
  schedulingAPI: 'https://qwikkitproductionscheduling.azurewebsites.net/api',
  signalRServerURL: 'https://qwikkitsignalr.azurewebsites.net',
  metricFunction: 'https://cinchhealth.azurewebsites.net/api/LogMetricFunction?code=uaaBE06eYSrAQzYSn/tWmtDEoTgQY59sbLEaySNszexHr9218hhwWA=='
};
